import styled from 'styled-components';
import bgAssine from '../../../assets/images/lps/bg-assine.png';

export const Content = styled.section`
  height: 100%;
  text-align: center;
  padding-top: 9rem;
  background: url(bgAssine);
  background-image: url(${bgAssine});
  position: relative;
  background-repeat: no-repeat;
  background-size: cover;
  color: #fff;
  &:before {
    content: ' ';
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 1) 100%);
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
  }
  h1 {
    font-weight: bold;
    font-size: 3.3rem;
    font-family: sans-serif;
  }
  p {
    font-family: sans-serif;
    font-size: 23px;
    margin-bottom: -20px;
    margin-top: 20px;
  }
  a {
    font-family: sans-serif;
    font-size: 20px !important;
    font-weight: bold !important;
    text-transform: uppercase;
    padding: 14px 45px 10px 45px !important;
    margin: 30px;
    &:hover {
      color: #fff;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/lps/subscription/style.js